import { FILTER_TYPE_SEPARATOR } from '../consts';
import { FilterCriteria, OfferDesignRow } from '../types';

export const getParam = (params: URLSearchParams, key: string): string =>
  params.get(key) || '';

export const getArrayParam = (params: URLSearchParams, key: string): string[] => {
  const value = params.get(key);
  return value ? value.split(FILTER_TYPE_SEPARATOR) : [];
};

export const toggleArrayValue = (current: string[], value: string): string[] =>
  current.includes(value)
    ? current.filter((v) => v !== value)
    : [...current, value];

export const filterOffers = (
  offers: OfferDesignRow[],
  { externalId, name, types }: FilterCriteria
): OfferDesignRow[] => {
  return offers.filter((offer) => {
    if (externalId && !offer.externalId?.toLowerCase().includes(externalId.toLowerCase())) {
      return false;
    }
    if (name && !offer.name?.toLowerCase().includes(name.toLowerCase())) {
      return false;
    }
    if (types.length > 0 && !types.includes(offer.offerUiType || '')) {
      return false;
    }
    return true;
  });
};
